<!-- TODO Check if enum vars can be referenced directly instead of values -->
<div id="block-referral">
  <label class="input-label" *ngIf="caption === 'referral'">Do you have a referral code? (Optional)</label>
  <label class="input-label" *ngIf="caption === 'partner'">Your partner code</label>
  <mat-form-field id="referral-input-container">
    <input matInput [(ngModel)]="referralCode"
           [disabled]="isCodeVerified() || isDisabled" id="referral-input">

    <button mat-stroked-button matSuffix class="btn-input-suffix" (click)="verifyReferralCode();
 analyticsTracker.trackButtonClick('Referral page', 'Verify')"
            *ngIf="!isCodeVerified() && verificationState !== VerificationState.IN_PROGRESS">VERIFY
    </button>

    <mat-spinner matSuffix [diameter]="25" *ngIf="verificationState === VerificationState.IN_PROGRESS"></mat-spinner>
    <i matSuffix class="fa fa-check tick-input-suffix" aria-hidden="true" *ngIf="isCodeVerified()"></i>
  </mat-form-field>
  <span *ngIf="verificationState === VerificationState.FAILED && isLoadingComplete"
        class="input-error-message">{{caption}} code provided is invalid.
          Please check the code and verify again.<br>
          If you don't have a {{caption}} code, please remove the code and then proceed.</span>
  <mat-spinner *ngIf="!isLoadingComplete" [diameter]="35"
               style="margin-left: auto; margin-right: auto;">
  </mat-spinner>
</div>
